import ReactSimpleWhiteBoard from '../Components/ReactSimpleWhiteBoard';


import React from 'react'

export const WhiteBoard = () => {
  return (
    <div id="demo">
        <ReactSimpleWhiteBoard/>
    </div>
  )
}
